import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import adminEsAr from './es-AR/admin.json';
import approvalsEsAr from './es-AR/approvals.json';
import assetsEsAr from './es-AR/assets.json';
import auditEsAr from './es-AR/audit.json';
import authEsAr from './es-AR/auth.json';
import automationEsAr from './es-AR/automation.json';
import billingEsAr from './es-AR/billing.json';
import clientsEsAr from './es-AR/clients.json';
import commonEsAr from './es-AR/common.json';
import dashboardsEsAr from './es-AR/dashboards.json';
import helpEsAr from './es-AR/help.json';
import knowledgeEsAr from './es-AR/knowledge.json';
import myWorkEsAr from './es-AR/myWork.json';
import navEsAr from './es-AR/nav.json';
import notificationsEsAr from './es-AR/notifications.json';
import platformEsAr from './es-AR/platform.json';
import portalEsAr from './es-AR/portal.json';
import reportsEsAr from './es-AR/reports.json';
import requestsEsAr from './es-AR/requests.json';
import searchEsAr from './es-AR/search.json';
import slaEsAr from './es-AR/sla.json';
import systemEsAr from './es-AR/system.json';
import tasksEsAr from './es-AR/tasks.json';
import ticketsEsAr from './es-AR/tickets.json';
import timeEsAr from './es-AR/time.json';

/**
 * D16: keys in English, values in es-AR, one namespace per module. The API answers with
 * error codes and never with user-facing text, so this is the only place where copy lives.
 */
export const defaultNS = 'common';

export const resources = {
  'es-AR': {
    admin: adminEsAr,
    approvals: approvalsEsAr,
    assets: assetsEsAr,
    audit: auditEsAr,
    auth: authEsAr,
    automation: automationEsAr,
    billing: billingEsAr,
    clients: clientsEsAr,
    common: commonEsAr,
    dashboards: dashboardsEsAr,
    help: helpEsAr,
    knowledge: knowledgeEsAr,
    myWork: myWorkEsAr,
    nav: navEsAr,
    notifications: notificationsEsAr,
    platform: platformEsAr,
    portal: portalEsAr,
    reports: reportsEsAr,
    requests: requestsEsAr,
    search: searchEsAr,
    sla: slaEsAr,
    system: systemEsAr,
    tasks: tasksEsAr,
    tickets: ticketsEsAr,
    time: timeEsAr,
  },
} as const;

export const supportedLngs = ['es-AR'] as const;

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    lng: 'es-AR',
    fallbackLng: 'es-AR',
    supportedLngs: [...supportedLngs],
    ns: [
      'admin',
      'approvals',
      'assets',
      'audit',
      'auth',
      'automation',
      'clients',
      'common',
      'dashboards',
      'help',
      'knowledge',
      'myWork',
      'nav',
      'notifications',
      'platform',
      'portal',
      'reports',
      'requests',
      'search',
      'sla',
      'system',
      'tasks',
      'tickets',
      'time',
    ],
    defaultNS,
    resources,
    interpolation: {
      // React already escapes everything it renders.
      escapeValue: false,
    },
    returnNull: false,
  });
}

export default i18n;
